export interface Installment {
  month3: number
  month6: number
}

export interface InstallmentOptions {
  [key: string]: {
    length: number
    price: number
  }[]
}

export interface Image {
  position: number
  url: string
  mediumImageUrl: string
  thumbImageUrl: string
}

export interface DeliveryOption {
  region: string
  courier: string
  minDays: number
  maxDays: number
  fee: number
}

export interface Variant {
  price: number
  description: string
}

export interface VendorInfo {
  name: string
  currency: string
  deliveryCountryId: string
}

export interface Item {
  id: string
  categoryIds: string[]
  vendorInfo?: VendorInfo
  title: string
  description: string
  options: string[]
  variants: Variant[]
  installmentOptions: InstallmentOptions | Installment[]
  images: Image[] | string[]
  isActive: boolean
  deliveryOptions: DeliveryOption[]
  giftBundleId?: string
  price: number
  thumbImageUrl: string
}

export interface ItemCard {
  imageSrc: string
  itemTitle: string
  itemDesc: string
  itemActive: boolean
  itemPrice: number
  itemId?: string
  itemButton?: string
  itemButtonUrl?: string
}

export const itemConverter: firebase.firestore.FirestoreDataConverter<Item> = {
  toFirestore: item => {
    return {
      categoryIds: item.categoryIds,
      vendorInfo: item.vendorInfo,
      title: item.title,
      description: item.description,
      options: item.options,
      variants: item.variants,
      installmentOptions: item.installmentOptions,
      images: item.images,
      isActive: item.isActive,
      deliveryOptions: item.deliveryOptions,
      giftBundleId: item.giftBundleId
    }
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)

    let sortedImages: Image[] = []
    if (data.images?.length) {
      sortedImages = data.images?.sort((a: Image, b: Image) => {
        return a.position < b.position ? -1 : a.position > b.position ? 1 : 0
      })
    }

    return {
      id: snapshot.id,
      categoryIds: data.categoryIds,
      vendorInfo: data.vendorInfo,
      title: data.title,
      description: data.description,
      options: data.options,
      variants: data.variants,
      installmentOptions: data.installmentOptions,
      images: data.images,
      isActive: data.isActive,
      deliveryOptions: data.deliveryOptions,
      giftBundleId: data.giftBundleId,
      price: data.variants?.length ? Number(data.variants[0].price) : 0,
      thumbImageUrl: sortedImages.length
        ? sortedImages[0].thumbImageUrl
        : '/image.png'
    }
  }
}
